import React from 'react';
import PropTypes from 'prop-types';
import IfElseConditionalRender from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/IfElseConditionalRender/IfElseConditionalRender';
import PublicDashboardEmptyAlertMessage from './PublicDashboardEmptyAlertMessage/PublicDashboardEmptyAlertMessage';
import DashboardEmptyAlertMessage from './DashboardEmptyAlertMessage/DashboardEmptyAlertMessage';

function DashboardEmptyAlertMessageRender({ isPublicDashboard }) {
  return (
    <IfElseConditionalRender
      TrueComponent={PublicDashboardEmptyAlertMessage}
      FalseComponent={DashboardEmptyAlertMessage}
      conditionalBool={isPublicDashboard}
    />
  );
}

DashboardEmptyAlertMessageRender.propTypes = {
  isPublicDashboard: PropTypes.bool.isRequired,
};

export default DashboardEmptyAlertMessageRender;
